import { Center, CenterProps, Icon, IconProps } from "@chakra-ui/react";
import { FaCheck } from "react-icons/fa";

type SelectionIndicatorProps = CenterProps & {
  icon?: React.ReactElement<IconProps> | null;
  isSelected?: boolean;
};

const SelectionIndicator = ({
  isSelected = false,
  icon = <Icon as={FaCheck} w={4} h={4} />,
  ...rest
}: SelectionIndicatorProps) => (
  <Center
    bg="bright.500"
    w="10"
    h="10"
    zIndex="dropdown"
    color="primary.500"
    opacity={isSelected ? "1" : "0"}
    transition="opacity 0.15s"
    {...rest}
  >
    {icon}
  </Center>
);

export default SelectionIndicator;
